export interface GallerySlide {
  src: string
  alt: string
}

export const insideItems: string[] = [
  'Cockpit visuals',
  'Aircraft control diagrams',
  'Flight maneuver sequences',
  'Takeoff progressions',
  'Traffic pattern visuals',
  'Approach sequences',
  'Landing sequences',
  'Navigation examples',
  'Radio communication frameworks',
  'Flight planning visuals',
  'Weather awareness tools',
  'Risk-management frameworks',
  'Correct-vs-incorrect comparisons',
  'Common student errors',
  'Instructor cues',
  'Quick corrections',
  'Training progression maps',
  'Student assessments',
  'Checklists',
  'Lesson structures',
  'Quick-reference tools',
]

export const gallerySlides: GallerySlide[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/jcr5awnBmLmuiifB8R7RKU/Captura_de_pantalla_2026-10-07_223435.png',
    alt: 'Takeoff — see the whole sequence: six-step visual from align to stabilize',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/uXVKx9h7qXbcWTkHLZKgLV/Captura_de_pantalla_2026-10-07_223459.png',
    alt: 'The complete traffic pattern in one visual: upwind, crosswind, downwind, base and final',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/bjPbRxKu2X3zw6gR7KmJ7v/Captura_de_pantalla_2026-10-07_223520.png',
    alt: 'Stable or unstable approach comparison with instructor criteria',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/3knBrP6mMwh9DMXs7sK2vL/Captura_de_pantalla_2026-10-07_223704.png',
    alt: 'Touchdown comparison: sideways drift, controlled touchdown and excessive correction',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/pH2eenGnTVMrwpabypiSfv/Captura_de_pantalla_2026-10-07_223756.png',
    alt: 'Fewer visual cues equals more discipline: day, night and reduced visibility runway views',
  },
]
